/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import ReactDOM from 'react-dom';

import EditButtons, {EditButtonStates} from 'metadata/EditButtons';
import CheckableReviewCriterionRow from 'notebook/reviews/CheckableReviewCriterionRow';
import {
  ConfigSavingState,
  ReviewCriteriaGroup,
  ReviewCriterion,
} from 'notebook/reviews/ReviewCriteriaConstants';
import ReviewCriteriaGroupHeader from 'notebook/reviews/ReviewCriteriaGroupHeader';
import FormInput from 'ui-library/bs/FormInput';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as modals from 'util/Modals';

interface CriterionRowProps {
  reviewCriterion: ReviewCriterion;
  isEditing: boolean;
  onChangeCriterion: (...args: Array<any>) => any;
  onDeleteCriterion: (...args: Array<any>) => any;
}

export function CriterionRow({
  reviewCriterion,
  isEditing,
  onChangeCriterion,
  onDeleteCriterion,
}: CriterionRowProps): JSX.Element {
  return isEditing ? (
    <div className="simpleDivTable-row">
      <div className="u-width-full flex-row-center">
        <FormInput autoFocus={false} value={reviewCriterion.text} onChange={onChangeCriterion} />
        <a className="faded u-danger-pointer u-small-padding-left" onClick={onDeleteCriterion}>
          <BenchlingIcon icon="delete" />
        </a>
      </div>
    </div>
  ) : (
    <CheckableReviewCriterionRow reviewCriterion={reviewCriterion} enabled={false} />
  );
}

interface ReviewCriteriaGroupConfigProps {
  pendingScrollIntoView: boolean;
  reviewCriteriaGroup: ReviewCriteriaGroup;
  savingState?: ConfigSavingState | null;
  writable: boolean;
  onAddCriterion: (...args: Array<any>) => any;
  onCancelEdit: (...args: Array<any>) => any;
  onChangeCriterion: (...args: Array<any>) => any;
  onChangeGroupName: (...args: Array<any>) => any;
  onDeleteCriterion: (...args: Array<any>) => any;
  onDeleteReviewCriteriaGroup: (...args: Array<any>) => any;
  onSaveReviewCriteriaGroup: (...args: Array<any>) => any;
  onScrollIntoView?: (...args: Array<any>) => any;
  onStartEdit: (...args: Array<any>) => any;
}

class ReviewCriteriaGroupConfig extends React.Component<ReviewCriteriaGroupConfigProps> {
  static defaultProps = {pendingScrollIntoView: false};

  override componentDidMount(): void {
    if (this.props.pendingScrollIntoView) {
      (ReactDOM.findDOMNode(this) as Element).scrollIntoView();
      this.props.onScrollIntoView!();
    }
  }

  _handleAddCriterion = (): void => {
    if (this.props.savingState === ConfigSavingState.NOT_EDITING) {
      this.props.onStartEdit(this.props.reviewCriteriaGroup);
    }
    this.props.onAddCriterion(this.props.reviewCriteriaGroup.id);
  };

  _handleCancelEdit = (): void => {
    this.props.onCancelEdit(this.props.reviewCriteriaGroup.id);
  };

  _handleChangeGroupName = (e: any): void => {
    this.props.onChangeGroupName(this.props.reviewCriteriaGroup.id, e.target.value);
  };

  _handleDelete = (): void => {
    modals
      .confirm(
        'Confirm Delete',
        'Are you sure you wish to delete this review criteria group? This action cannot be undone.',
        'danger'
      )
      .done(() => this.props.onDeleteReviewCriteriaGroup(this.props.reviewCriteriaGroup.id));
  };

  _handleSave = (): void => {
    this.props.onSaveReviewCriteriaGroup(this.props.reviewCriteriaGroup);
  };

  _handleStartEdit = (): void => {
    this.props.onStartEdit(this.props.reviewCriteriaGroup);
  };

  override render(): JSX.Element {
    return (
      <div className="reviewCriteriaGroupConfig">
        <div className="simpleDivTable">
          <ReviewCriteriaGroupHeader
            onAddCriterion={
              this.props.writable && this.props.savingState !== ConfigSavingState.SAVING
                ? this._handleAddCriterion
                : null
            }
            renderGroupName={() =>
              this.props.savingState === ConfigSavingState.EDITING ? (
                <FormInput
                  placeholder="Group Name"
                  value={this.props.reviewCriteriaGroup.name}
                  onChange={this._handleChangeGroupName}
                />
              ) : (
                <div>{this.props.reviewCriteriaGroup.name}</div>
              )
            }
            renderControls={() =>
              this.props.writable && (
                <div>
                  {this.props.savingState === ConfigSavingState.NOT_EDITING && (
                    <Button
                      buttonStyle={ButtonStyle.NEGATIVE}
                      className="u-mini-spacing-right"
                      icon="delete"
                      onClick={this._handleDelete}
                      size={ButtonSize.MINI}
                    />
                  )}
                  <EditButtons
                    editingState={
                      {
                        [ConfigSavingState.NOT_EDITING]: EditButtonStates.NOT_EDITING,
                        [ConfigSavingState.EDITING]: EditButtonStates.EDITING,
                        [ConfigSavingState.SAVING]: EditButtonStates.SAVING,
                      }[this.props.savingState!]
                    }
                    onCancel={this._handleCancelEdit}
                    onComplete={this._handleSave}
                    onEdit={this._handleStartEdit}
                    saveDisabled={this.props.reviewCriteriaGroup.name.trim().length === 0}
                  />
                </div>
              )
            }
            shouldRenderPassFail={this.props.savingState !== ConfigSavingState.EDITING}
          />
          {this.props.reviewCriteriaGroup.reviewCriteria.map((criterion: any, i: any) => (
            <CriterionRow
              key={criterion.id || `new-criterion-${i}`}
              reviewCriterion={criterion}
              isEditing={this.props.savingState === ConfigSavingState.EDITING}
              onChangeCriterion={(e) =>
                this.props.onChangeCriterion(this.props.reviewCriteriaGroup.id, i, e.target.value)
              }
              onDeleteCriterion={() => this.props.onDeleteCriterion(this.props.reviewCriteriaGroup.id, i)}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default ReviewCriteriaGroupConfig;
